module.exports = __webpack_public_path__ + "img/Telegram.16279421.png";